/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteUserSettingsParams,
  GetUserSettingsParams,
  PatchUserSettingsParams,
  PostUserSettingsParams,
  PostgrestError,
  UserSettings,
  UserSettingsInsertPayload,
  UserSettingsUpdate
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getUserSettingsResponse200 = {
  data: UserSettings[]
  status: 200
}

export type getUserSettingsResponse206 = {
  data: UserSettings[]
  status: 206
}

export type getUserSettingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getUserSettingsResponseSuccess = (getUserSettingsResponse200 | getUserSettingsResponse206) & {
  headers: Headers;
};
export type getUserSettingsResponseError = (getUserSettingsResponseDefault) & {
  headers: Headers;
};

export type getUserSettingsResponse = (getUserSettingsResponseSuccess | getUserSettingsResponseError)

export const getGetUserSettingsUrl = (params?: GetUserSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/user_settings?${stringifiedParams}` : `${backendBaseUrl}/user_settings`
}

/**
 * @summary Read rows from `user_settings`.
 */
export const getUserSettings = async (params?: GetUserSettingsParams, options?: RequestInit): Promise<getUserSettingsResponse> => {

  const res = await fetch(getGetUserSettingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getUserSettingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getUserSettingsResponse
}


export type postUserSettingsResponse201 = {
  data: UserSettings[]
  status: 201
}

export type postUserSettingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postUserSettingsResponseSuccess = (postUserSettingsResponse201) & {
  headers: Headers;
};
export type postUserSettingsResponseError = (postUserSettingsResponseDefault) & {
  headers: Headers;
};

export type postUserSettingsResponse = (postUserSettingsResponseSuccess | postUserSettingsResponseError)

export const getPostUserSettingsUrl = (params?: PostUserSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/user_settings?${stringifiedParams}` : `${backendBaseUrl}/user_settings`
}

/**
 * @summary Insert one or more rows into `user_settings`.
 */
export const postUserSettings = async (userSettingsInsertPayload: UserSettingsInsertPayload,
    params?: PostUserSettingsParams, options?: RequestInit): Promise<postUserSettingsResponse> => {

  const res = await fetch(getPostUserSettingsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userSettingsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postUserSettingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postUserSettingsResponse
}


export type patchUserSettingsResponse200 = {
  data: UserSettings[]
  status: 200
}

export type patchUserSettingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchUserSettingsResponseSuccess = (patchUserSettingsResponse200) & {
  headers: Headers;
};
export type patchUserSettingsResponseError = (patchUserSettingsResponseDefault) & {
  headers: Headers;
};

export type patchUserSettingsResponse = (patchUserSettingsResponseSuccess | patchUserSettingsResponseError)

export const getPatchUserSettingsUrl = (params?: PatchUserSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/user_settings?${stringifiedParams}` : `${backendBaseUrl}/user_settings`
}

/**
 * @summary Update the rows of `user_settings` matching the given filters.
 */
export const patchUserSettings = async (userSettingsUpdate: UserSettingsUpdate,
    params?: PatchUserSettingsParams, options?: RequestInit): Promise<patchUserSettingsResponse> => {

  const res = await fetch(getPatchUserSettingsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userSettingsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchUserSettingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchUserSettingsResponse
}


export type deleteUserSettingsResponse200 = {
  data: UserSettings[]
  status: 200
}

export type deleteUserSettingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteUserSettingsResponseSuccess = (deleteUserSettingsResponse200) & {
  headers: Headers;
};
export type deleteUserSettingsResponseError = (deleteUserSettingsResponseDefault) & {
  headers: Headers;
};

export type deleteUserSettingsResponse = (deleteUserSettingsResponseSuccess | deleteUserSettingsResponseError)

export const getDeleteUserSettingsUrl = (params?: DeleteUserSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/user_settings?${stringifiedParams}` : `${backendBaseUrl}/user_settings`
}

/**
 * @summary Delete the rows of `user_settings` matching the given filters.
 */
export const deleteUserSettings = async (params?: DeleteUserSettingsParams, options?: RequestInit): Promise<deleteUserSettingsResponse> => {

  const res = await fetch(getDeleteUserSettingsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteUserSettingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteUserSettingsResponse
}


